import React from 'react'
import ReactDOM from 'react-dom'
import { HashRouter as Router } from 'react-router-dom'
import Root from './containers/Root'
import configureStore from './store/configureStore'
import axios from 'axios'
import config from 'react-observable-store'
import registerServiceWorker from './registerServiceWorker'
import './assets/index.css'


// Define initiater
const init = (globals) => {

    // Set global configuration
    config.init({ globals: globals })

    // Create redux store
    const store = configureStore()

    // Debug redux store
    if (globals.debugReduxStore) {
        store.subscribe((a) => {
            console.log(store.getState())
        })
    }

    ReactDOM.render(
        <Router>
            <Root store={store} />
        </Router>
        , document.getElementById('root')
    )
}

// On error fallback
const onConfigError = (error) => {
    ReactDOM.render(
        <div className="container">
            <div className="row">
                <div className="col-md-12 text-center">
                    <h1>SIARL - Módulo de Reporte de Ocorrências no Litoral</h1>
                    <p>Sistema em Manutenção. Voltamos brevemente.</p>
                </div>
            </div>
        </div>
        , document.getElementById('root')
    )
}

// Load configuration
axios.get('/config.json')
.then(res => {
    if (res.status === 200) {
        init(res.data)
    } else {
        onConfigError(res.status)
    }
})

registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js